import { render, staticRenderFns } from "./AdmissionsByDay.vue?vue&type=template&id=5c0e2715"
import script from "./AdmissionsByDay.vue?vue&type=script&lang=js"
export * from "./AdmissionsByDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0e2715')) {
      api.createRecord('5c0e2715', component.options)
    } else {
      api.reload('5c0e2715', component.options)
    }
    module.hot.accept("./AdmissionsByDay.vue?vue&type=template&id=5c0e2715", function () {
      api.rerender('5c0e2715', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Admissions/AdmissionsByDay.vue"
export default component.exports